/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBankAccountCommand
 */
export interface UpdateBankAccountCommand {
    /**
     * International Bank Account Number
     * @type {string}
     * @memberof UpdateBankAccountCommand
     */
    iban: string;
    /**
     * Bank Identifier Code (BIC/SWIFT)
     * @type {string}
     * @memberof UpdateBankAccountCommand
     */
    bic?: string | null;
    /**
     * Label or name of the bank account
     * @type {string}
     * @memberof UpdateBankAccountCommand
     */
    label: string;
    /**
     * Indicates if this should be the default bank account for the person
     * @type {boolean}
     * @memberof UpdateBankAccountCommand
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the UpdateBankAccountCommand interface.
 */
export function instanceOfUpdateBankAccountCommand(value: object): value is UpdateBankAccountCommand {
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UpdateBankAccountCommandFromJSON(json: any): UpdateBankAccountCommand {
    return UpdateBankAccountCommandFromJSONTyped(json, false);
}

export function UpdateBankAccountCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBankAccountCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'iban': json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function UpdateBankAccountCommandToJSON(json: any): UpdateBankAccountCommand {
    return UpdateBankAccountCommandToJSONTyped(json, false);
}

export function UpdateBankAccountCommandToJSONTyped(value?: UpdateBankAccountCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'isDefault': value['isDefault'],
    };
}

